 


    <nb-card *ngIf="loaded">

        <nb-card-header>
          
            <div style="display:flex; width:100%">
                <span>Налаштування ретрансляції</span>   
                 <span style="display:flex; margin-left:auto; cursor: pointer;" >
			<nb-icon [icon]="'close-outline'" (click)="closeModal()" pack="eva"></nb-icon>
		</span>  
                </div>
        </nb-card-header>

        <nb-card-body class="settingsModalBody">
       
        <restream-player #video [hasSignal]="true" [sources]="[{  src: '/preview/restream/'+restream.restreamKey+'.flv', type: 'application/x-mpegURL' }]"></restream-player>
        
        
        
 
            <div>
            <div class="headSettings">
 
                <div >
                       <input  nbInput (change)="saveDisabled = false"  type="text" [(ngModel)]="titleValue" />
                </div> 
                <div  class="restreamConnection">
                    <div style="margin-bottom:10px;"> 
                        <span>rtmp://{{domain.name}}/restream</span>
                         <span style="margin-left: auto; display: flex;">
                            <a class="copyLink"  href="javascript:;"   (cbOnSuccess)="showToastCopyClipboard('Скопійовано в буфер обміну')" 
            ngxClipboard [cbContent]="'rtmp://'+domain.name+'/restream'"
                            >Копіювати</a>
                        </span>
                    </div>
                    <div> 
                        <span>{{restream.restreamKey}}</span>    
                         <span style="margin-left: auto; display: flex;">
                             <a class="copyLink"  href="javascript:;" (cbOnSuccess)="showToastCopyClipboard('Скопійовано в буфер обміну')"     ngxClipboard [cbContent]="restream.restreamKey"
                            >Копіювати</a>
                        </span>
                    </div>
                </div>


            </div>



                <div>

   


    <div>

 
        <div class="restreamsItems scrollable-container">

        <div *ngFor="let restr  of restreams; let i = index" class="channel" >
		    
	<div style="display:block;" class="head">
		     
		<div style="display:block; float:left;" >Канал {{i+1}}</div>
		 <div  style="display:block; float:right; margin-left:auto;width:170px;" > 
			<div  style="display:flex">
				<div  class="toggle hideMobile">Старт</div>
				<div    class="toggle hideMobile">Автостарт</div>
	 
	  		 </div>
               </div>
		<div style="clear:both"></div>
	    </div>
           <div  class="item">

	<div  class="inputs">
           <div class="restreamsItemsItem leftInput">
               <input placeholder="RTMP URL" [(ngModel)]="restr.url" (change)="saveDisabled = false" nbInput type="text" />
               <div class="text-danger" *ngIf="restr.errorUrl">{{restr.errorUrl}}</div>
           </div> 

            
            
           <div class="restreamsItemsItem rightInput" >
            <input placeholder="RTMP ключ"  nbInput [(ngModel)]="restr.key" (change)="saveDisabled = false" type="text" />
            <div class="text-danger" *ngIf="restr.errorKey">{{restr.errorKey}}</div>
 
        </div> 

        </div> 
	

<div class="controlls">

        <div    class="toggle restreamsItemsItem">   
               <div   style="display:flex; margin: auto;"> 
   <span class="showMobile label lbl">Старт: </span>
            <nb-toggle [disabled]="!restream.hasSignal || restr.unsaved"  [(ngModel)]="restr.running" [status]="restr.running ? 'success':'primary'" (checkedChange)="changeRestreamRunningStatus($event, restr)" status="primary"></nb-toggle>
        </div>
        </div>
 

        <div    class="toggle restreamsItemsItem">
            <div style="display:flex; margin: auto;"> 
           <span class="showMobile label lbl">Автостарт: </span> <nb-checkbox  [(ngModel)]="restr.active" (change)="saveDisabled = false" status="primary" ></nb-checkbox>

            </div>
        </div>
 
        
           
        <div style="display:none">
            <input nbInput [(ngModel)]="restr.login" type="text" />
            <div class="text-danger" *ngIf="restr.errorLogin">{{restr.errorLogin}}</div>

        </div> 

         
           
        <div style="display:none">
            <input nbInput [(ngModel)]="restr.password" type="text" />
            <div class="text-danger" *ngIf="restr.errorPassword">{{restr.errorPassword}}</div>

        </div> 



        <div class="remove restreamsItemsItem">

 
	 <div style="display:flex; margin:auto">
	   <span class="showMobile label lbl">Видалити: </span>
            <nb-icon  style="cursor: pointer;" (click)="deleteItem(restr)" status="danger" [icon]="'trash-outline'"   pack="eva"></nb-icon>
		 
 	</div>

</div>




        </div>



        </div>

        </div>
    </div>


        <div style="display: flex;">
            <div style="padding-top:10px">
		<button nbButton status="primary" (click)="addItem()" >Додати канал</button>
 
            </div>
        </div>

    </div>
 
                </div>







            </div>

	 
           <ng-template #loading>
            <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
            <div style="margin: auto;"> 
                 <app-loader></app-loader>
             </div>
            </div>
        </ng-template> 
</nb-card-body>
     
<nb-card-footer>
          
    <div style="display:flex; width:100%">
          <div style="display:flex; margin-left:auto;  " >
            <button nbButton status="basic" (click)="closeModal()" >Скасувати</button>
            <button style="margin-left: 15px;" [disabled]="saveDisabled"
            nbButton status="success" (click)="save()" >Застосувати</button>

        </div>  
     </div>
</nb-card-footer>
</nb-card>
  


 
